<template>

  <div style="width: 100%;height: 100%;background-color: #3E414A">
    <div style="justify-content: center;align-content: center;padding-top: 20px;padding-bottom: 20px">
      <div style="color: #FFFFFF;text-align: center">Register</div>
    </div>
    <div style="margin: 30px">
      <div style="display:flex;flex-direction:row;align-items:center;height:40px;background-color: #141517;border-radius: 17px">
        <div style="width: 90px"/>
        <el-input style="font-size: 12px;" v-model="mail" placeholder="Enter your email"/>
      </div>
      <div style="margin-top:20px;display:flex;flex-direction:row;align-items:center;height:40px;background-color: #141517;border-radius: 17px">
        <div style="width: 90px">
          <el-select v-model="prefix" placeholder="" suffix-icon="">
            <el-option
                v-for="item in prefixList"
                :key="item.value"
                :label="item.label"
                :value="item.name">
            </el-option>
          </el-select>
        </div>
        <el-input style="font-size: 12px;" v-model="phone" placeholder="Enter your mobile"/>
      </div>
      <div style="margin-top:20px;display:flex;flex-direction:row;align-items:center;height:40px;background-color: #141517;border-radius: 17px">
        <div style="width: 90px"/>
        <el-input style="font-size: 12px;" v-model="code" placeholder="Enter verification code"/>
        <div style="padding-right:10px;font-size:13px;position:absolute;color: #6B8F1A;width: 160px;text-align: right;right: 1px;margin-right: 30px" @click="getyzm">{{text}}</div>
      </div>
      <div style="margin-top:20px;display:flex;flex-direction:row;align-items:center;height:40px;background-color: #141517;border-radius: 17px">
        <div style="width: 90px"/>
        <el-input style="font-size: 12px;" v-model="password" placeholder="Please input password"/>
      </div>
      <div style="margin-top:60px;justify-content: center;align-content: center;background-color: #6B8F1A;border-radius: 17px;padding-top: 10px;padding-bottom: 10px" @click="onRegister">
        <div style="color: #FFFFFF;text-align: center">Register</div>
      </div>
    </div>
  </div>
</template>

<script>
import Detail from "../home/HomeCaseDetails";
export default {
  components: {Detail},
  data () {
    return {
      mail:'',
      phone:'',
      code:'',
      password: '',
      prefixList: [], //前缀数组
      prefix: '', //前缀手机号
      default:'Get code',
      text:'Get code',
      times: 60,
      resend:'SResend',
      parentId:''
    }
  },
  created () {
    this.getPrefix();
    if(this.$route.query.parentId){
      this.parentId=this.$route.query.parentId
      console.log("parentId==>",this.$route.query.parentId)
    }
  },
  mounted () {

  },
  methods: {
    getPrefix() {
      this.$api.prefix({}).then(res => {
        console.log(res);
        if (res.result == 0) {
          this.prefixList = res.dataList;
          this.prefix = res.dataList[0].name;
        }
      });
    },
    // 手机号前缀
    selectcity(e) {
      this.prefix = e.target.value;
    },
    getyzm() {
      if(this.text != this.default){
        return;
      }
      var myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
      if (!myreg.test(this.phone)) {
        this.$message({
          message: 'Mobile phone number input error!',
          type: 'error',
          center: true,
          duration: 1000
        });
        return;
      }
      let data = {
        prefix: this.prefix,
        phone: this.phone
      };
      this.$api.code(data).then(res => {
        console.log(res);
        if (res.result == 0) {
          this.getcode();
        } else {
          this.$message({
            message: res.resultNote,
            type: 'error',
            center: true,
            duration: 1000
          });
        }
      });
    },
    getcode() {
      var num = 60;
      this.yzmbotshou = false;
      this.yzmbothide = true;
      var interval = setInterval(() => {
        --this.times;
        this.text=this.times+this.resend
      }, 1000);
      setTimeout(() => {
        clearInterval(interval);
        this.times = num;
        this.text=this.default;
      }, 60000);
    },
    onRegister(){
      if (this.mail == '') {
        this.$message({
          message: 'Please fill in the email',
          type: 'error',
          center: true,
          duration: 1000
        });
        return;
      }
      if (this.phone == '') {
        this.$message({
          message: 'Please fill in the phone',
          type: 'error',
          center: true,
          duration: 1000
        });
        return;
      }
      if (this.code == '') {
        this.$message({
          message: 'Please enter the verification code',
          type: 'error',
          center: true,
          duration: 1000
        });
        return;
      }
      if (this.password.length < 6) {
        this.$message({
          message: 'The password must be at least six digits',
          type: 'error',
          center: true,
          duration: 1000
        });
        return;
      }
      let data = {
        mail: this.mail,
        phone: this.phone,
        prefix:this.prefix?this.prefix:'+86',
        code:this.code,
        password:this.$md5(this.password),
        parentId:this.parentId
      };

      this.$api.registerApp(data).then((res)=>{
        console.log(res);
        if(res.result==0){
          this.$router.push({ path: '/pgyer' });
        }else{
          this.$message({
            message: res.resultNote,
            type: 'error',
            center: true,
            duration: 1000
          });
        }
      })
    }
  }
}
</script>

<style lang="scss">
.el-input .el-input__inner {
  background-color: #00000000; /* 输入框背景色 */
  color: #FFFFFF; /* 输入框文本颜色 */
}
.el-input .el-input__inner:focus {
  border-color: #00000000; /* 输入框焦点边框色 */
}
.li3_left {
  select {
    width: 70px;
    height: 40px;
    background: rgba(35, 254, 246, 0.1);
    border: 1px solid rgba(72, 236, 231, 0.3);
    color: #13fffc;
    outline: none;
    padding-left: 10px;
    box-sizing: border-box;
    font-size: 16px;
    option {
      background: #000;
      color: #00d9dd;
    }
  }
}
</style>
